import { Component, Vue } from 'vue-property-decorator';
import ProjectStatistics from '@/components/pages/contribution-levels/statistics/project-statistics/ProjectStatistics.vue';
import UserStatistics from '@/components/pages/contribution-levels/statistics/user-statistics/UserStatistics.vue';
import DropStatistics from '@/components/pages/contribution-levels/statistics/drop-statistics/DropStatistics.vue';

enum TabItem {
  ByUser = 'By User',
  ByProject = 'By Project',
  ByDrop = 'By Pollens',
}

@Component({
  components: {
    ProjectStatistics,
    UserStatistics,
    DropStatistics
  }
})
export default class Statistics extends Vue {
  private tab = null;
  private readonly tabItems = [
    { title: TabItem.ByUser, component: UserStatistics },
    { title: TabItem.ByProject, component: ProjectStatistics },
    { title: TabItem.ByDrop, component: DropStatistics },
  ];
}
